import {Button, Col, Row} from 'antd';
import React, {useCallback, useEffect} from 'react';
import {generatePath, useHistory, useLocation, useRouteMatch} from 'react-router-dom';
import {createQuery, refreshQueryRequests, selectCurrent} from '../../containers/CohortBuilder/cohortBuilderSlice';
import {useAppDispatch, useAppSelector} from '../../hooks';
import {Routes} from "../../pages/routes";
import {isDefined} from '../../reducers/util';
import styles from './ListQueries.module.scss';
import buttonStyles from "../../components/common/styled/Buttons.module.scss";
import {QueryCard} from "./QueryCard";
import {selectResources} from "../../actions/userSlice";
import {ModulePermission, Resources} from "../../actions/api";
import {CohortDataset} from "../../containers/HealthcareUsageReport/types/CohortQuery";
import {getCohortBuilderResource} from "../query-builder/components/DatasetList";
import {isRunning} from "../../containers/CohortBuilder/cohortStatus";

const UPDATE_INTERVAL = 1000 * 60;

export const datasets = (resources: Resources | undefined): CohortDataset[] => {
    if (resources) {
        const cohortBuilderResult = getCohortBuilderResource(resources);
        if (cohortBuilderResult) {
            return cohortBuilderResult.children.map(i => i.code.replace(ModulePermission.COHORT_BUILDER + '_', '') as CohortDataset)
        }
    }
    return []
}

const ListQueries = () => {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const projectMatch = useRouteMatch(Routes.Project)
    const history = useHistory()
    const { study, query: selectedQuery } = useAppSelector(selectCurrent)
    const queries = study.queries

    const resources = useAppSelector(selectResources)
    const permittedCbDatasets = datasets(resources)

    const refreshData = useCallback(() => {
        const runningQueries = queries
            .filter(query => isRunning(query));

        if (isDefined(runningQueries) && runningQueries.length > 0) {
            // TODO: maybe use study id instead
            dispatch(refreshQueryRequests(runningQueries.map(i => i.id)))
        }
    }, [queries, dispatch])

    // https://upmostly.com/tutorials/build-a-react-timer-component-using-hooks
    useEffect(() => {
        let interval = setInterval(() => {
            refreshData()
        }, UPDATE_INTERVAL);
        return () => clearInterval(interval);
    }, [refreshData]);

    return <Row className="queries-list" >
            <Col span={24}>
                <Row className={styles['queries-title']}>
                    <Col span={12} className="justify-left">Project - Cohorts</Col>
                    {
                        location.pathname === Routes.MyHRU || study.example ?
                            null :
                            <Col span={12} className="justify-right">
                                <Button
                                    className={`${buttonStyles["primary"]} ${styles['build-btn']}`}
                                    type="primary"
                                    onClick={() => {
                                        dispatch(createQuery({dataset: permittedCbDatasets[0]}))
                                        history.push(generatePath(Routes.Project, {
                                            ...projectMatch.params,
                                            studyId: undefined,
                                            study: undefined,
                                            subpage: 'period'
                                        }))
                                    }}
                                    data-testid="build-new-cohort-button"
                                >
                                    Build a new Cohort
                                </Button>
                            </Col>}
                </Row>
                {
                    queries?.length > 0 ? queries.map(query => {
                        return <QueryCard
                            key={query.id}
                            query={query}
                            selectedQuery={selectedQuery}
                            projectMatch={projectMatch}
                            history={history}
                            location={location}
                            dispatch={dispatch}
                            permittedDatasets={permittedCbDatasets}
                         />
                    }) : null
                }
            </Col>
        </Row>
    
}

export default ListQueries